import I18n from 'i18n-js';
import { StringSchema } from 'yup';

import {
  passwordAtLeastOneNumberSchema,
  passwordLengthSchema,
  passwordLowerAndUpperCaseSchema,
} from '@lootboy/lib/forms/common';

export type TValidationHint = {
  message: string;
  schema: StringSchema;
};

export const passwordValidationSchema = [
  {
    message: I18n.t('MenuView_password_1_bpoint'),
    schema: passwordLengthSchema,
  },
  {
    message: I18n.t('MenuView_password_2_bpoint'),
    schema: passwordLowerAndUpperCaseSchema,
  },
  {
    message: I18n.t('MenuView_password_3_bpoint'),
    schema: passwordAtLeastOneNumberSchema,
  },
];
